import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Dialog, DialogFooter, PrimaryButton } from '@fluentui/react';
const dialogContentStyles = {
    subText: {
        whiteSpace: 'pre-line'
    }
};
const dialogContentProps = (context)=>{
    return {
        title: context.loc('PowerBIVisual_DownloadSampleModal_Header'),
        subText: [
            context.loc('PowerBIVisual_DownloadSampleModal_Body_1'),
            context.loc('PowerBIVisual_DownloadSampleModal_Body_2')
        ].join('\n'),
        showCloseButton: true,
        styles: dialogContentStyles
    };
};
export const DownloadSampleModal = ({ context, dismissModal })=>{
    return /*#__PURE__*/ _jsx(Dialog, {
        hidden: false,
        dialogContentProps: dialogContentProps(context),
        onDismiss: dismissModal,
        maxWidth: 560,
        children: /*#__PURE__*/ _jsx(DialogFooter, {
            children: /*#__PURE__*/ _jsx(PrimaryButton, {
                text: context.loc('Common_Ok'),
                name: "button",
                type: "submit",
                onClick: dismissModal
            })
        })
    });
};
